import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { Key } from 'lucide-react'

export function CayuKeysBadge() {
  const { t } = useTranslation('conversations')
  return (
    <Badge variant="secondary" className="bg-purple-100 text-purple-700 border-purple-200">
      <Key className="w-3 h-3 mr-1" />
      {t('integrations.cayuKeys.badge')}
    </Badge>
  )
}
